/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { ConfigurationPanelEntrypointProps } from './ConfigurationPanel.entrypoint.types.tsx';

type ConfigurationTabEntryPointComponent = EntryPointComponent<
	{},
	{},
	ConfigurationPanelEntrypointProps,
	{}
>;

export const configurationTabEntryPoint: EntryPoint<ConfigurationTabEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<ConfigurationTabEntryPointComponent>(
			/* webpackChunkName: "async-configuration-tab" */ './ConfigurationPanel.tsx',
		),
		getPreloadProps: () => ({
			extraProps: {},
		}),
	});
